import React from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { observer } from 'mobx-react';

import RFQIntro from 'apps/rfq/rfqPage/views/rfqIntro';
import DetailsBlock from 'apps/rfq/rfqPage/views/detailsBlock';
import NeedPerfectQuote from 'apps/rfq/rfqPage/views/needPerfectQuote';

import { ShipmentQuotes } from '../../ShipmentQuotes';

import { IntermediatorRFQProductQuotes } from './IntermediatorRFQProductQuotes';

const IntermediatorRFQPage = observer(props => {
  const { rfqManager } = props;
  const { rfqApp } = rfqManager;
  // const { quoteFormStore } = quotesManager;
  // const quoteFormRef = useRef(null);
  // const forwardedQuotesRef = useRef(null);
  // useEffect(() => {
  //   quotesManager.forwardedQuotesRef = forwardedQuotesRef;
  // }, [forwardedQuotesRef]);
  return (
    <>
      <RFQIntro rfqManager={rfqManager} rfqApp={rfqApp} isIntermediator />
      <NeedPerfectQuote rfqManager={rfqManager} />
      <DetailsBlock rfqManager={rfqManager} jobSpec={rfqApp.jobSpec} />
      {/* <RFQAssigner rfqManager={rfqManager} /> */}
      <ShipmentQuotes
        rfqId={rfqApp.id}
        shipmentQuotes={rfqApp.shipmentQuotes.apps}
      />
      <IntermediatorRFQProductQuotes rfqApp={rfqApp} />
    </>
  );
});

IntermediatorRFQPage.propTypes = {
  rfqManager: PropTypes.object,
  quotesManager: PropTypes.object,
};

export default withNamespaces()(IntermediatorRFQPage);
